import React from "react";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary";
};

const Button: React.FC<ButtonProps> = ({ variant = "primary", className = "", children, ...props }) => {
  const base = "rounded-lg px-4 py-2 font-semibold font-body text-xl transition-colors disabled:opacity-50 disabled:cursor-not-allowed";
  const variants = {
    primary: "bg-primary text-white hover:bg-ink",
    secondary: "bg-transparent text-primary border border-primary hover:bg-lightbg",
  };
  return (
    <button className={`${base} ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
};

export default Button;
